import {makeStyles} from '@material-ui/core/styles';
import Colors from '../../../helpers/Colors';

export const ModalStyles = makeStyles(() => ({
    container: {
        width: '55vw',
        height: '60vh',
        maxWidth: '1024px',
        maxHeight: '592px',
        backgroundColor: Colors.white,
        borderRadius: '6px',
        fontFamily: 'Inter'
    },

    closeButton: {
        float: 'right'
    },

    body: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '90%',
        flexWrap: 'wrap',
        overflow: 'auto'
    },

    leftPanel: {
        display: 'flex',
        flex: 0.5,
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center'
    },

    rightPanel: {
        display: 'flex',
        flex: 0.5,
        flexDirection: 'column',
        width: '100%',
        alignItems: 'flex-start',
        justifyContent: 'center',
        padding: '0 10%'
    },

    titleText: {
        color: Colors.colorNeutralTitleModal,
        fontSize: '34px',
        fontWeight: 500,
        paddingBottom: '20px'
    },

    subText: {
        color: Colors.colorNeutralTitleModal,
        fontSize: '21px',
        fontWeight: 400
    },

    inputField: {
        fontSize: '24px',
        fontWeight: 400
    },

    buttonContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'space-between',
        justifyContent: 'space-between',
        width: '100%',
        paddingTop: '40px'
    },

    button: {
        display: 'flex',
        flex: 0.5,
        flexGrow: 1,
        margin: '5%',
        fontSize: '16px',
        fontWeight: 500,
        borderRadius: '6px',
        textTransform: 'none',
        fontFamily: 'Inter'
    }
}));